//frontend/src/applications/administrator/navigation.js

import {
  FaHome,
  FaCalendarAlt,
  FaMapMarkedAlt,
  FaMoneyBillWave,
  FaCalculator,
  FaUsers,
  FaTruck,
  FaBoxOpen,
  FaShippingFast,
  FaClipboardList,
  FaRoute,
  FaQuestionCircle,
  FaSearch,
  FaUserPlus,  
} from "react-icons/fa";

export const administratorNavigation = [
  {
    id: "dashboard",
    icon: FaHome,
    label: "Обзор",
    path: "/",
  },
  {
    id: "calendar",
    icon: FaCalendarAlt,
    label: "Календарь",
    path: "/calendar",
  },
  {
    id: "map",
    icon: FaMapMarkedAlt,
    label: "Карта",
    path: "/map",
  },
  {
    id: "finance",
    icon: FaMoneyBillWave,
    label: "Финансы",
    path: "/finance",
  },
  {
    id: "accounting",
    icon: FaCalculator,
    label: "Бухгалтерия",
    path: "/accounting",
  },
  {
    id: "clients",
    icon: FaUsers,
    label: "Клиенты",
    path: "/clients",
  },
  {
    id: "suppliers",
    icon: FaTruck,
    label: "Поставщики",
    path: "/suppliers",
  },
  {
    id: "products",
    icon: FaBoxOpen,
    label: "Товары",
    path: "/products",
  },
  {
    id: "expeditors",
    icon: FaShippingFast,
    label: "Экспедиторы",
    path: "/expeditors",
  },
  {
    id: "orders",
    icon: FaClipboardList,
    label: "Заказы",
    path: "/orders",
  },
  {
    id: "tracking",
    icon: FaRoute,
    label: "Отслеживание",
    path: "/tracking",
  },
  {
    id: "help",
    icon: FaQuestionCircle,
    label: "Помощь",
    path: "/help",
  },

  {
    id: "request-search",
    icon: FaSearch,
    label: "Заявка на поиск",
    path: "/request-search",
  },

  {
    id: "eco-calculator",
    icon: FaCalculator,          // компонент, а не строка
    label: "Калькулятор РОП",    // label, а не title
    path: "/admin/eco-calculator",
  },
  
  {
    id: "users",
    icon: FaUserPlus,
    label: "Пользователи",
    path: "/users",
  },


];
